<template>
  <div class="sites">
    <div class="panelheader">
      <div class="title">{{pageName}}</div>
    </div>
    <el-row>
      <el-col :xs="{span: 0}" :sm="{span: 14}" :md="{span: 14}" :lg="{span: 18}">
        <div class="site-view">
         <gmap-map
          :center=this.center
          :zoom=this.zoom
          style="width: 98%; height: 500px">
           <gmap-marker
              :key="index"
              v-for="(m, index) in markers"
              :position="m.position"
              :clickable="true"
              :draggable="false"
              :icon="m.icon"
              :title="m.label"
              @click="center=m.position">
            </gmap-marker>
          </gmap-map>
        </div>
      </el-col>
      <el-col :xs="{span: 24}" :sm="{span: 10}" :md="{span: 10}" :lg="{span: 6}" class="site-panel">
        <el-table
          :data="tableData"
          style="width: 100%"
          class="site-table"
          @row-click="goToSite"
          @row-dblclick="viewSiteInfo"
          empty-text="No sites">
          <el-table-column label="Sites">
            <template slot-scope="props">
              <p class="hidden">{{ props.row.id }}</p>
              <div class="name">{{ props.row.name }}</div>
              <div class="clear"></div><br>
              <span class="address">{{ props.row.address }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import * as VueGoogleMaps from 'vue2-google-maps';
import Vue from 'vue';
import auth from '../auth';
import requests from '../requests';
  
const mapIconURL = 'http://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2%7C';
var colorMap = {
  0: mapIconURL + 'FFFF57', //YELLOW
  1: mapIconURL + '34BA46', //GREEN
  2: mapIconURL + '0B0BFF', //BLUE
  3: mapIconURL + 'FE7569' //RED
}
  
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDQQiPUztxjJ_Lcx59IoScQkj7T_NLLP7U',
  }
});
export default {
  name: 'sites',
  data () {
    return {
      tableData: [],
      markers: [],
      center: {},
      zoom: '',
      pageName: 'Sporting Grounds'
    }
  },
  beforeMount(){
    var profile = JSON.parse(auth.getProfile());
    this.center = {lat: parseFloat(profile.lat), lng: parseFloat(profile.long)}
    this.zoom = profile.zoom
    var uri = auth.getApi();
    var header = {headers: auth.getAuthHeader()}
    
    if(profile.role != 3){
      this.$http.get(uri + '/api/sites/' + profile.client_id,{headers:{'x-access-token':header['headers']['x-access-token']}}).then(result=>{
        var sites = result.body.data;
        for(var site in sites){
          // console.log(sites[site].name, parseFloat(sites[site].latitude), parseFloat(sites[site].longitude), colorMap[site % 4]);
          this.tableData.push(sites[site]);
          this.markers.push({label:sites[site].name, position: {lat: parseFloat(sites[site].latitude), lng: parseFloat(sites[site].longitude)}, icon: {'url':colorMap[site % 4]}});
        }
      });
    } else {
      var context = this;
      requests.getAllSites(this, function(result){
        var sites = result.data;
        for(var site in sites){
          context.tableData.push(sites[site]);
          context.markers.push({label:sites[site].name, position: {lat: parseFloat(sites[site].latitude), lng: parseFloat(sites[site].longitude)}, icon: {'url':colorMap[site % 4]}});
        }
      });
    }
  },
  watch: {
    '$route'(to, from) {
      // Call resizePreserveCenter() on all maps
      Vue.$gmapDefaultResizeBus.$emit('resize')
    }
  },
  mounted(){

  },
  methods: {
    goToSite(row, event){
      // if the map isn't rendered (eg: on mobile) go straight to site info
      if ($('.vue-map')[0].clientWidth <= 0) {
        return this.viewSiteInfo(row)
      }

      this.center = {'lat':parseFloat(row.latitude), 'lng': parseFloat(row.longitude)}
      this.zoom = row.zoom
    },
    viewSiteInfo(row, event){
      this.$router.push({path:'/site/' + row.id});
    }
  }
}
</script>

<style>
  
  .site-table {
    font-size: 12px;
  }
  
  .site-table .name, .site-table .address {
    line-height: 1;
    float: left;
    text-align: left;
  }
  
  .site-table .name {
    font-weight: 600;
    margin-bottom: 0.4em;
  }
  
  .site-table .address {
    color: #656565;
    padding-bottom: 0.6em;
  }

  .site-view, .site-panel {
    background-color: white;
  }
  
  .site-view {
    padding: 2em 0 2em 2em;
  }
  
  .site-panel {
    padding-top:2em;
    padding-right: 2em;
    padding-bottom: 2em;
  }
  
  .site-table {
    height: 500px;
    border: none;
    background-color: white;
    overflow-y: scroll;
  }
  
  .site-view .el-table::before, .el-table::after{
    background-color: unset;
  }
  
  .site-table tr td {
    cursor: pointer;
    border: none;
  }
  
  .site-view el-table__row {
    display: block;
    border-bottom: 1px solid #F3F3F5;
  }
  
  .sites .el-table .cell {
    margin-top: 1em;
    border-bottom: 1px solid #F3F3F5
  }
  
</style>



// WEBPACK FOOTER //
// Sites.vue?3e9b2ea7